define([
	"dojo/_base/declare",
	"csi/heading/BooleanController",
	"csi/xml"
], function(declare,BooleanController,xml) {

	return declare(BooleanController, {
		toWriter: function() {
			// summary: add/remove size to/from Style.InactiveSizes
			var	size = this._ctx.getNode();
			if (size) {
				var	bAdd = (this.keyContainer == -1);
				this.m_writer.changeNode(this.m_urlNode).changeAttribute(this.heading.m_id, xml.ATTR_REFSET, [size.$URL], bAdd, !bAdd);
			}
		}
	});
});